export default "__VITE_ASSET__DPeL56_v__"